import Calendar from "components/common/Calendar";
import { motion } from "framer-motion";
import moment from "moment";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { timeInstructionData } from "./ServicesProceduresPayerResponse";

const PreauthorizationServicesProceduresNested = () => {
  const { preauthorizationRequest, viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );
  const { claimRequestData } = useSelector((state) => state.claim);

  const cliamPreauthorization =
    preauthorizationRequest?.entry?.find(
      (e) => e.resource?.resourceType === "Claim"
    )?.resource ||
    claimRequestData?.entry?.find((e) => e.resource?.resourceType === "Claim")
      ?.resource;

  const claimMedicals =
    preauthorizationRequest?.entry
      ?.filter((e) => e.resource?.resourceType === "MedicationRequest")
      ?.map((e) => e.resource) ||
    claimRequestData?.entry
      ?.filter((e) => e.resource?.resourceType === "MedicationRequest")
      ?.map((e) => e.resource) ||
    [];

  const practitioner =
    preauthorizationRequest?.entry?.filter(
      (e) => e.resource?.resourceType === "Practitioner"
    ) ||
    claimRequestData?.entry?.filter(
      (e) => e.resource?.resourceType === "Practitioner"
    );
  console.log({ practitioner });
  const supportingInfo =
    cliamPreauthorization?.supportingInfo ||
    claimRequestData?.entry?.find((e) => e.resource?.supportingInfo)?.resource
      ?.supportingInfo;

  const diagnosis = cliamPreauthorization?.diagnosis;

  const transformFHIRToServiceData = () => {
    let medicationIndex = 0;
    return cliamPreauthorization?.item?.map((entry, index) => {
      const viewService = viewPreauthorizationInfo?.service_procedures?.[index];

      const getExtensionValue = (urlPart) =>
        entry.extension?.find((ext) => ext?.url?.includes(urlPart));

      const prescripedMedication = getExtensionValue(
        "extension-prescribed-Medication"
      );
      const pharmacySubstitue = getExtensionValue(
        "extension-pharmacist-substitute"
      );
      const strength = getExtensionValue("extension-strength");
      const selectionReason = getExtensionValue("extension-Selection-Reason");
      const absenceReason = getExtensionValue(
        "extension-absence-of-scientific-code"
      );
      const maternityExt = getExtensionValue("extension-maternity");
      const vatExt = getExtensionValue("extension-tax");
      const patientShareExt = getExtensionValue("extension-patient-share");
      const patientInvoiceExt = getExtensionValue("extension-patientInvoice");

      const patientShare = parseFloat(patientShareExt?.valueMoney?.value || 0);
      const strengthValue = strength?.valueString;
      const unitPrice = parseFloat(entry.unitPrice?.value || 0);
      const quantity = parseFloat(entry.quantity?.value || 0);
      const factor = parseFloat(entry.factor || 1);
      const discount = unitPrice * quantity * (1 - factor);

      const netAmt = entry?.net?.value;

      // Get diagnosis information
      const diagnosisSequences = entry.diagnosisSequence || [];
      const diagnosisCodes = diagnosisSequences
        .map((seq) => {
          const diag = diagnosis?.find((d) => d.sequence === seq);
          return diag?.diagnosisCodeableConcept?.coding?.[0]?.code;
        })
        .filter((code) => code)
        .join(", ");

      // Get tooth number and body site
      const toothNo = entry?.bodySite?.coding?.[0]?.code || "-";
      const bodySiteCode = entry?.bodySite?.coding?.find((coding) =>
        coding?.system?.includes("fdi-oral-region")
      )?.code;

      const subSiteCode = entry?.subSite?.find((item) =>
        item?.coding?.[0]?.system?.includes("subsite")
      )?.coding?.[0]?.code;

      // Medication-related fields
      const medCode =
        prescripedMedication?.valueCodeableConcept?.coding?.[0]?.code || "-";
      const substitutePharmacy =
        pharmacySubstitue?.valueCodeableConcept?.text ||
        pharmacySubstitue?.valueCodeableConcept?.coding?.[0]?.display ||
        "-";
      const otherSubstituePharmacy =
        pharmacySubstitue?.valueCodeableConcept?.coding?.[0]?.code || "-";
      const selectReason =
        selectionReason?.valueCodeableConcept?.coding?.[0]?.code || "-";
      const absenceRsn =
        absenceReason?.valueCodeableConcept?.coding?.[0]?.code || "-";
      const scientificCodeOtherReason =
        absenceReason?.valueCodeableConcept?.text ||
        absenceReason?.valueCodeableConcept?.coding?.[0]?.display ||
        "-";

      // Service type
      const serviceSystem = entry.productOrService?.coding?.[0]?.system || "";
      const type = !serviceSystem.includes("medication-codes")
        ? "Procedures"
        : "Medication";

      let claimMedical = null;
      let claimMedicalCode = "";
      let claimMedicalDisplay = "";
      let claimRoute = "";
      let dosageData = null;

      if (type === "Medication" && medicationIndex < claimMedicals.length) {
        claimMedical = claimMedicals[medicationIndex];
        claimMedicalCode =
          claimMedical?.medicationCodeableConcept?.coding?.[0]?.code || "";
        claimMedicalDisplay =
          claimMedical?.medicationCodeableConcept?.coding?.[0]?.display || "";
        claimRoute =
          claimMedical?.dosageInstruction?.[0]?.route?.coding?.[0]?.display ||
          "";
        dosageData = claimMedical?.dosageInstruction?.[0];
        medicationIndex++;
      }

      // Prescribed medication type and code (mimicking useEffect logic)
      const prescribedMedicationType = claimMedicalCode
        ? { servtype_code: "itm_medcde", servtype_name: "Medical Code" }
        : null;
      const prescribedMedicationCode = claimMedicalCode
        ? {
          prodserv_code: claimMedicalCode || "",
          prodserv_desc: claimMedicalDisplay || "",
          provider_code: "",
          unit_price: 0,
          price_discount: 0,
          price_tax: "15",
          provider_codedesc: "",
          prdurl: "",
          prodserv_unittyp: "",
          prodserv_pcksze: "",
          prodserv_strngt: "",
        }
        : null;

      // Invoice number
      const invoiceNo =
        claimRequestData?.id && patientInvoiceExt?.valueIdentifier?.value
          ? patientInvoiceExt.valueIdentifier.value
          : "-";

      // Dosage instruction fields
      const startDate = dosageData?.timing?.repeat?.boundsPeriod?.start
        ? moment(dosageData.timing.repeat.boundsPeriod.start).format(
          "DD/MM/YYYY"
        )
        : "-";
      const endDate = dosageData?.timing?.repeat?.boundsPeriod?.end
        ? moment(dosageData.timing.repeat.boundsPeriod.end).format("DD/MM/YYYY")
        : "-";

      // Lab tests
      const labTests = (entry.informationSequence || [])
        .map((seq) => {
          const info = supportingInfo?.find((i) => i.sequence === seq);
          const isLabTest = info?.category?.coding?.some(
            (c) => c.code === "lab-test"
          );
          if (isLabTest) {
            const labCode = info?.code?.coding?.[0]?.code;
            return {
              loinc_code: labCode || "-",
              loinc_description: info?.code?.coding?.[0]?.display || "-",
              loinc_uom: "",
            };
          }
          return null;
        })
        .filter(Boolean);

      const periodStartDate = dosageData?.timing?.repeat?.boundsPeriod?.start;
      const periodEndDate = dosageData?.timing?.repeat?.boundsPeriod?.end;
      const duration = dosageData?.timing?.repeat?.duration;
      const durationType = dosageData?.timing?.repeat?.durationUnit;
      const frequency = dosageData?.timing?.repeat?.frequency;
      const period = dosageData?.timing?.repeat?.period;
      const periodType = dosageData?.timing?.repeat?.periodUnit;
      const dose = dosageData?.doseAndRate?.[0]?.doseQuantity?.value;
      const doseType = dosageData?.doseAndRate?.[0]?.doseQuantity?.code;
      const timeInstruction = timeInstructionData?.find(
        (item) =>
          item?.time_instCode === dosageData?.timing?.code?.coding[0]?.code
      )?.time_instDisplay;

      const refill = dosageData?.timing?.repeat?.count;
      const patientInst = dosageData?.patientInstruction;
      const dosageInst = dosageData?.text;
      // Service dates
      const serviceStartDate = entry.servicedPeriod?.start
        ? moment(entry.servicedPeriod.start).format("DD/MM/YYYY")
        : "-";
      const serviceEndDate = entry.servicedPeriod?.end
        ? moment(entry.servicedPeriod.end).format("DD/MM/YYYY")
        : "-";

      return {
        id: index + 1,
        nphiesCode: entry.productOrService?.coding?.[0]?.code || "",
        internalCode: entry.productOrService?.coding?.[1]?.code || "",
        nphiesDescription: entry.productOrService?.coding?.[0]?.display || "",
        internalDescription: entry.productOrService?.coding?.[1]?.display || "",
        date: moment(entry.servicedPeriod?.start).format("DD/MM/YYYY"),
        type: viewService?.servinfo_prdtyp,
        unitPrice: `${unitPrice.toFixed(2)} SAR`,
        discount: `${discount.toFixed(2)} SAR`,
        quantity: `${quantity.toFixed(2)}`,
        patientShare: `${patientShare.toFixed(2)} SAR`,
        invoiceNo,
        netAmount: `${entry.net?.value?.toFixed(2)} ${entry.net?.currency || "SAR"
          }`,
        vatAmount: `${vatExt?.valueMoney?.value?.toFixed(2) || "0.00"} SAR`,
        diagnosis: diagnosisCodes || "-",
        toothNo,
        practitioner: practitioner?.[index]?.resource?.name?.[0]?.text || "-",
        isMaternity: maternityExt?.valueBoolean ? "Yes" : "No",
        medCode,
        substitutePharmacy,
        otherSubstituePharmacy,
        netAmt,
        selectReason,
        strengthValue,
        absenceRsn,
        scientificCodeOtherReason,
        service_start_date: serviceStartDate,
        service_end_date: serviceEndDate,
        dosageInst,
        service_type: {
          servtype_code: viewService?.prdtyp,
          servtype_name: viewPreauthorizationInfo?.servinfo_prdtyp,
        },
        service_code_description: {
          prodserv_code: entry.productOrService?.coding?.[0]?.code || "",
          prodserv_desc: entry.productOrService?.coding?.[0]?.display || "",
          provider_code: "",
          unit_price: unitPrice || 0,
          price_discount: discount || 0,
          price_tax: vatExt?.valueMoney?.value || "15",
          provider_codedesc: "",
          prdurl: "",
          prodserv_unittyp: "",
          prodserv_pcksze: "",
          prodserv_strngt: "",
          value: "",
          label: "",
        },
        prescribed_medication_type: prescribedMedicationType,
        prescribed_medication_code: prescribedMedicationCode,
        lab_tests: labTests,
        scientic_code_absence: absenceRsn !== "-" ? absenceRsn : null,
        pharmacist_substitute:
          otherSubstituePharmacy !== "-" ? otherSubstituePharmacy : null,
        substitute_reason_other:
          substitutePharmacy !== "-" ? substitutePharmacy : "-",
        selection_reason: selectReason !== "-" ? selectReason : null,
        period_start: periodStartDate,
        period_end: periodEndDate,
        duration,
        duration_type: durationType,
        frequency,
        period,
        period_type: periodType,
        selectReason,
        dose,
        dose_type: doseType,
        time_inst: timeInstruction,
        refill,
        patient_inst: patientInst,
        body_site: bodySiteCode ? { bodysite_code: bodySiteCode } : null,
        sub_site: subSiteCode ? { bodysubsite_code: subSiteCode } : null,
        claimMedicalDisplay,
        claimRoute,
      };
    });
  };

  const serviceData = transformFHIRToServiceData();

  // Calculate totals
  const totalNet =
    serviceData?.reduce((sum, item) => {
      const net = parseFloat(item.netAmount.replace(" SAR", "")) || 0;
      return sum + net;
    }, 0) || 0;

  const totalVat =
    serviceData?.reduce((sum, item) => {
      const vat = parseFloat(item.vatAmount.replace(" SAR", "")) || 0;
      return sum + vat;
    }, 0) || 0;

  const total = totalNet + totalVat;

  const totalPatientShare =
    serviceData?.reduce((sum, item) => {
      const net = parseFloat(item.patientShare) || 0;
      return sum + net;
    }, 0) || 0;

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {/* Floating Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success px-3 py-2">
          <span className="fs-11">Service & Procedures</span>
        </span>
      </div>

      <Row className="mt-2">
        {serviceData?.map((item) => {
          const [dayStr, monthStr, yearStr] = item.date.split("/"); // "22", "04", "2025"
          const dateObj = new Date(`${yearStr}-${monthStr}-${dayStr}`); // → "2025-04-22" (ISO format)
          const formatter = new Intl.DateTimeFormat("en", {
            month: "short", // use 'long' for full month name like "April"
            day: "2-digit",
            year: "numeric",
          });
          const parts = formatter.formatToParts(dateObj);
          const day = parts.find((p) => p.type === "day")?.value;
          const month = parts.find((p) => p.type === "month")?.value;
          const year = parts.find((p) => p.type === "year")?.value;
          const hasPrescriptionDetails =
            (item.medCode && item.medCode !== "-") ||
            item.claimMedicalDisplay ||
            (item.strengthValue && item.strengthValue !== "-") ||
            (item.absenceRsn && item.absenceRsn !== "-") ||
            (item.selectReason && item.selectReason !== "-") ||
            (item.otherSubstituePharmacy &&
              item.otherSubstituePharmacy !== "-") ||
            (item.substitutePharmacy && item.substitutePharmacy !== "-") ||
            (item.period_start && item.period_end) ||
            item.duration ||
            (item.frequency && item.period && item.period_type) ||
            (item.dose && item.dose_type) ||
            item.claimRoute ||
            item.time_inst ||
            item.refill ||
            item?.dosageInst ||
            item.patient_inst;
          return (
            <Col xs={12} key={item.id} className="mb-3">
              <Card className="p-3 h-100">
                <Row className="g-3">
                  <Col xs={12} md={2} className="text-center">
                    <div className="category-sevie badge-subtle-success text-success fs-10">
                      {item.id}
                    </div>
                    <div className="mt-3">
                      <Calendar month={month} day={day} year={year} />
                    </div>
                  </Col>
                  <Col xs={12} md={10}>
                    <Row>
                      {/* Code & Description */}
                      <Col xs={12} className="d-flex flex-wrap gap-3 mb-2">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div className="badge badge-subtle-success p-2">
                            {item.nphiesCode}
                          </div>
                          <div className="fs-10">{item.nphiesDescription}</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div className="badge badge-subtle-warning p-2">
                            {item.internalCode}
                          </div>
                          <div className="fs-10">
                            {item.internalDescription}
                          </div>
                        </div>
                      </Col>

                      {/* Main Details */}
                      <Col xs={12}>
                        <Row className="gy-2">
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 fw-semibold">Type</span>
                              <span className="fs-10 text-600">
                                {item.type}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Unit Price
                              </span>
                              <span className="fs-10  fw-bold">
                                {item.unitPrice}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 fw-bold">
                                Discount Amount
                              </span>
                              <span className="fs-10  fw-semibold">
                                {item.discount}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Quantity
                              </span>
                              <span className="fs-10 text-600">
                                {item.quantity}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Patient Share
                              </span>
                              <span className="fs-10 text-600 ">
                                {item.patientShare}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Net Amount
                              </span>
                              <span className="fs-10 fw-bold ">
                                {item.netAmt}
                              </span>
                            </div>
                          </Col>
                          {item.invoiceNo && item.invoiceNo !== "-" && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-800 fw-bold">
                                  Invoice No
                                </span>
                                <span className="fs-10 fw-bold text-info">
                                  {item.invoiceNo}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Tooth No
                              </span>
                              <span className="fs-10 fw-bold ">
                                {item.toothNo}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Diagnosis
                              </span>
                              <span className="fs-10 text-600">
                                {item.diagnosis}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Practitioner
                              </span>
                              <span className="fs-10 text-600">
                                {item.practitioner}
                              </span>
                            </div>
                          </Col>
                          <Col xs={6} md={2}>
                            <div className="d-flex flex-column">
                              <span className="fs-10 text-800 fw-bold">
                                Is Maternity
                              </span>
                              <span className="fs-10 text-600">
                                {item.isMaternity}
                              </span>
                            </div>
                          </Col>
                          {hasPrescriptionDetails && (
                            <div className="fs-9 text-success fw-bold mb-2 border-bottom py-2">
                              Prescription Details
                            </div>
                          )}
                          {item.medCode && item.medCode !== "-" && (
                            <Col xs={6} md={2}>
                              <div className="d-flex  flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Code
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.medCode}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.claimMedicalDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Prescribed Medication Desc.
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.claimMedicalDisplay}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.strengthValue && item.strengthValue !== "-" && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Strength
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.strengthValue}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.absenceRsn && item.absenceRsn !== "-" && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Absence Reason
                                </span>
                                <span className="fs-10 text-capitalize text-info-emphasis">
                                  {item.absenceRsn}
                                </span>
                              </div>
                            </Col>
                          )}

                          {item.selectReason && item.selectReason !== "-" && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Selection Reason
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.selectReason}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.otherSubstituePharmacy &&
                            item.otherSubstituePharmacy !== "-" && (
                              <Col xs={6} md={2}>
                                <div className="d-flex flex-column">
                                  <span className="fs-10 text-info fw-bold">
                                    Pharmacist Substitute
                                  </span>
                                  <div className="d-flex flex-column">
                                    <span className="fs-10 text-info-emphasis">
                                      {item.otherSubstituePharmacy}
                                    </span>
                                    {item.substitutePharmacy &&
                                      item.substitutePharmacy != "-" && (
                                        <span className="fs-10 text-info-emphasis">
                                          ({item.substitutePharmacy || ""})
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </Col>
                            )}

                          {item?.period_start && item?.period_end && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Period
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {`${item?.period_start} - ${item?.period_end}`}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.duration && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Duration
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {`${item?.duration} ${item?.duration_type || "d"
                                    }`}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.duration &&
                            item?.period &&
                            item?.period_type && (
                              <Col xs={6} md={2}>
                                <div className="d-flex flex-column">
                                  <span className="fs-10 text-info fw-bold">
                                    Frequency
                                  </span>
                                  <span className="fs-10 text-info-emphasis">
                                    {`(${item?.frequency || ""}) - ${item?.period
                                      } ${item?.period_type}`}
                                  </span>
                                </div>
                              </Col>
                            )}
                          {item?.dose && item?.dose_type && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dose
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {`${item?.dose} ${item?.dose_type}`}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item.claimMedicalDisplay && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Route
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item.claimRoute}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.time_inst && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Time Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item?.time_inst}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.refill && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Refill
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item?.refill}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.dosageInst && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Dosage Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item?.dosageInst}
                                </span>
                              </div>
                            </Col>
                          )}
                          {item?.patient_inst && (
                            <Col xs={6} md={2}>
                              <div className="d-flex flex-column">
                                <span className="fs-10 text-info fw-bold">
                                  Patient Instruction
                                </span>
                                <span className="fs-10 text-info-emphasis">
                                  {item?.patient_inst}
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          );
        })}
        <Row>
          <Col xs={12}>
            <Card className="p-3">
              <Row className="g-3">
                <Col xs={12} md={4} className="text-start">
                  <div className="d-flex flex-column">
                    <span className="fs-10 text-800 fw-bold">
                      Total Net Amount
                    </span>
                    <span className="fs-10 fw-bold text-primary">
                      {totalNet.toFixed(2)} SAR
                    </span>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-start">
                  <div className="d-flex flex-column">
                    <span className="fs-10 text-800 fw-bold">Total VAT</span>
                    <span className="fs-10 fw-bold text-primary">
                      {totalVat.toFixed(2)} SAR
                    </span>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-start">
                  <div className="d-flex flex-column">
                    <span className="fs-10 text-800 fw-bold">
                      Total Patient Share
                    </span>
                    <span className="fs-10 fw-bold text-success">
                      {totalPatientShare.toFixed(2)} SAR
                    </span>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Row>
    </motion.div>
  );
};

export default PreauthorizationServicesProceduresNested;
